import React from 'react';
import { WindowBody } from '@ff-os/shared-react/components/window/partials/WindowBody';
import { WindowFooter } from '@ff-os/shared-react/components/window/partials/WindowFooter';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { Window } from '@ff-os/shared-react/components/window/Window';
import { PhotoPrintsOrderButton } from '../PhotoPrintsOrderButton';
import { PhotoPrintsWindowErrors } from '../PhotoPrintsWindowErrors';
import { PhotoPrintGroupsList } from './PhotoPrintGroupsList';
import styles from './PhotoPrintsWindowMobile.module.scss';

export const PhotoPrintsWindowMobile = ({ close }: Props) => (
    <Window fullHeight fullWidth close={close}>
        <WindowHeader onClose={close} />
        <WindowBody>
            <PhotoPrintGroupsList />
        </WindowBody>
        <PhotoPrintsWindowErrors />
        <WindowFooter>
            <PhotoPrintsOrderButton className={styles.orderButton} />
        </WindowFooter>
    </Window>
);

type Props = {
    close: () => void;
};